import { VRadioGroup } from "vuetify/lib";
import Vue from "vue";

const VRadioGroupExtended = {
  extends: VRadioGroup,

  methods: {
    getValue(item: any) {
      return item?.value || null;
    }
  }
};

Vue.component("v-radio-group-extended", VRadioGroupExtended);

export default VRadioGroupExtended;
